<script>
export default {};
</script>

<template>
  <div>
    <!--START WEBSITE-DESCRIPTION-->
    <section class="section section-lg bg-web-desc">
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="text-white">¿Sabía usted...</h2>
            <p class="padding-t-15 home-desc"> que en los Estados Unidos por ley todos los vehículos deben contar con un
              seguro de responsabilidad civil y daños contra terceros?
            </p>
            <a href="https://chubbcrossborder.com/chubb/NbB2C_cotiza1.php?agentId=3255" Target="_blank"
              class="btn btn-bg-white margin-t-30 waves-effect waves-light mb-5">¡Contrata tu
              seguro ahora!</a>
          </div>
        </div>
      </div>
      <div class="bg-pattern-effect">
        <img src="@/assets/images/bg-pattern.png" alt />
      </div>
    </section>

    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>